import { Formik, Field } from 'formik';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack
} from '@mui/material';
import { TagPickerField } from '../../entities/tag/ui/tag-picker-field';

type EditTagsDialogProps = {
  open: boolean;
  onClose: () => void;
  selected: (number | string)[];
  onSave: (newSelected: (number | string)[]) => void;
};

export const EditTagsDialog = ({
  open,
  onClose,
  selected,
  onSave,
}: EditTagsDialogProps) => {
  return (
    <Formik
      initialValues={{ tags: selected ?? [] }}
      onSubmit={(values) => {
        onSave(values.tags);
        onClose();
      }}
    >
      {({ submitForm, isSubmitting }) => (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
          <DialogTitle>Редактирование тегов</DialogTitle>
          <DialogContent>
            <Stack direction="column" spacing={2} sx={{ mt: 2 }}>
              <Field name="tags" component={TagPickerField} />
            </Stack>
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose}>Отмена</Button>
            <Button
              variant="contained"
              onClick={submitForm}
              disabled={isSubmitting}
            >
              Сохранить
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
};
